/**
 * Copyright © 2018 Emu Analytics
 */

import { Client } from './client';
import { BaseEndpoints } from './base.endpoints';
import { IDatabase } from './api-interfaces';

export class DatabaseEndpoints extends BaseEndpoints<IDatabase> {
  constructor(client: Client) {
    super(client, 'databases');
  }

  drivers(): Promise<string[]> {
    return this.client._get(`/api/v1/databases/drivers`).catch(e => {
      if (e.status === 404) {
        // Backwards compatibility for pre-1.0.0 Flo.w
        return ['postgis', 'postgis-mapnik'];
      }
    });
  }
}
